import { Controller } from "@hotwired/stimulus"

/**
 * Voice Selector Controller
 *
 * Handles voice selection UI with search, filtering, and favorites toggle.
 */
export default class extends Controller {
  static targets = ["searchInput", "voiceList", "voiceCard"]

  connect() {
    this.filterVoices = this.filterVoices.bind(this)
  }

  filterVoices() {
    const query = this.searchInputTarget.value.toLowerCase().trim()

    this.voiceCardTargets.forEach(card => {
      const name = card.dataset.voiceName?.toLowerCase() || ""
      const language = card.dataset.voiceLanguage?.toLowerCase() || ""
      const accent = card.dataset.voiceAccent?.toLowerCase() || ""

      const matches = !query ||
        name.includes(query) ||
        language.includes(query) ||
        accent.includes(query)

      card.classList.toggle("hidden", !matches)
    })
  }

  async toggleFavorite(event) {
    event.preventDefault()
    event.stopPropagation()

    const button = event.currentTarget
    const url = button.dataset.favoriteUrl

    if (!url) {
      console.error("No favorite URL provided")
      return
    }

    try {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "application/json"
        }
      })

      const data = await response.json()

      if (response.ok && data.success) {
        // Toggle the star visual state
        const svg = button.querySelector("svg")
        if (data.favorited) {
          svg.setAttribute("fill", "currentColor")
          button.classList.remove("text-gray-300")
          button.classList.add("text-yellow-400")
          button.title = "Remove from favorites"
        } else {
          svg.setAttribute("fill", "none")
          button.classList.remove("text-yellow-400")
          button.classList.add("text-gray-300")
          button.title = "Add to favorites"
        }
      } else {
        console.error("Failed to toggle favorite:", data.error)
      }
    } catch (error) {
      console.error("Toggle favorite failed:", error)
    }
  }
}
